import { ToastContainer, Toast } from "react-bootstrap";
import {useToast} from "./ToastProvider";
import { useRef } from "react"; //useEffect, useState,
function ToastNotificacion(){
    const toastP = useToast();
   // const [toastClass, setToastClass] = useState(0);
    const toastRef = useRef(null);

    //onMouseEnter={() => toast.setShowToast(false)}
    //useEffect(() => {
      //  const { top } = toastRef.current.getBoundingClientRect();
        //setToastClass(top);
        // const listenScrollEvent = () => {
        //     window.scrollY > 20 ? setToastClass({
        //         position: "sticky",
        //         top: `${top}px`,
        //         zIndex: 1100
        //     }) : setToastClass({ zIndex: 1 })
        // }
        //
        // window.addEventListener("scroll", listenScrollEvent)
        //
        //
        // return () => {
        //     window.removeEventListener("scroll", listenScrollEvent)
        // };
    //},[]);

    function removeToast(id){
        toastP.setArrayToast(prevToasts => prevToasts.filter(toast => toast.id !== id) )
    }

    return (
        <ToastContainer
            className="p-3 position-fixed"
            position={'bottom-end'}
            style={{
                zIndex: 1100
            }}
            ref={toastRef}
        >
            {
                toastP.arrayToast && toastP.arrayToast.map((toast) => {
                    return(
                        <Toast key={toast.id} id={toast.id} onClose={() => removeToast(toast.id)} show={toast.show} delay={10000} autohide={true} >
                            <Toast.Header>
                                <i className={"ki-duotone ki-notification-on fs-3 text-" + toast.color}>
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                    <span className="path3"></span>
                                    <span className="path4"></span>
                                    <span className="path5"></span>
                                </i>
                                <strong className="ms-2 me-auto">Camelus</strong>
                                <small>Hace un momento</small>
                            </Toast.Header>
                            <Toast.Body>
                                {toast.text}
                            </Toast.Body>
                        </Toast>
                    );
                })
            }
        </ToastContainer>
    );
}

export default ToastNotificacion;
